import { AssistentItem } from '../assistent_config';
import { EinstellungBeraterButtonWrapper } from './wrapper/EinstellungBeraterButtonWrapper';
import { IDs } from '../../../../helpers/IDs';
import * as React from 'react';
import { showKostenKonfiguration } from '../../../../helpers/showKosten';
import { WFormData } from '../../../../core/forms/WFormFramework';

export function getAssistentConfigKonfig(dataGlobal: any, onRoutingChange: (routing: any) => void, isAdmin: boolean, bereichKey: string, customCfg?: AssistentItem): AssistentItem {
    const konfiguration: any = (dataGlobal[IDs.ENT_KONFIGURATION] || [])[0] || {};
    const alternatives_system: number = konfiguration.alternatives_system_orig || konfiguration.alternatives_system || 0;
    const co2_fussabdruck_flag = konfiguration.co2_fussabdruck_orig === 1;
    const co2_fussabdruck_modus_ghg = konfiguration.co2_fussabdruck_modus === 'ghg';
    const handwerk_flag: boolean = bereichKey === 'handwerk';
    const kultur_flag: boolean = bereichKey === 'kultur';
    const privat_flag: boolean = bereichKey === 'privat';
    const showKosten: boolean = showKostenKonfiguration(dataGlobal);
    const styleAdminOnly: React.CSSProperties = { color: '#aaa' };
    // const berater_flag = konfiguration.berater_zugriff_orig === 1;
    // const beraterItem: WFormConfigItem = {
    //     typ: 'custom',
    //     key:  'btnBerater',
    //     label: berater_flag ? '' : '',
    //     disabled: true,
    //     disableHelp: true,
    //     custom_renderer: () => {
    //         const konf: any[ = dataGlobal[IDs.ENT_KONFIGURATION] || [];
    //         const flag = konf.length > 0 && konf[0].berater_zugriff_orig === 1 || konf[0].berater_zugriff === 1;
    //         return (flag ? <EinstellungBeraterButtonWrapper
    //         data={dataGlobal}
    //         onRoutingChange={onRoutingChange}
    //     /> : <div style={{ height: 20 }}></div>);
    //     },
    //     custom_component: () => <div></div>,
    //     custom_setCloseHandler: () => { }
    // };
    const customCssStyle: any = {
        formField: {
            berater_zugriff: {
                classInput: { paddingBottom: 0 }
            }
        },
        formTitel: {
            fontStyle: 'italic',
            fontWeight: 'normal',
            textAlign: 'left',
            textDecoration: 'underline',
            color: '#4472c4',
            backgroundColor: 'inherit',
            marginBottom: 10,
            padding: 0
        },
        label: {
            alternatives_system: (alternatives_system !== 1 || kultur_flag || privat_flag) ? (isAdmin ? styleAdminOnly : {}) : {},
            etool_test: styleAdminOnly,
            auto_save_intervall: styleAdminOnly,
            vsme: styleAdminOnly
        }
    };
    const eingabe_konfig = {
        gliederung: '1.1',
        name: 'Konfiguration',
        description: 'Dies ist das Formular zur Eingabe der Konfigurations-Daten.',
        type: 'EntityForm',
        entity: IDs.ENT_KONFIGURATION,
        module: IDs.MOD_ETOOL,
        style: { marginLeft: 18 },
        extraFormElementAfter: {
            externer_berater:
                <div style={{ marginBottom: 20, marginLeft: 63 }}>
                    <EinstellungBeraterButtonWrapper
                        data={dataGlobal}
                        onRoutingChange={onRoutingChange}
                    />
                </div>
        },
        // additionalFormItems: [beraterItem],
        // disablePruefer: true,
        singleItem: true,
        configFlag: 'checkConfig',
        customCssStyle,
        selectOptionAsRadio: true,
        /*customTopElement: (entity: string, item: any, callback?: (data: any) => void) =>
            <EinstellungBeraterButtonWrapper
                data={dataGlobal}
                onRoutingChange={onRoutingChange}
        />,*/
        customFormConfig: {
            startjahr_datenerfassung: { hidden: true },
            energiesteuerrueckerstattung: { hidden: true },
            mehrere_standorte: { hidden: privat_flag },
            daten_maschinen: { hidden: privat_flag },
            gefuehrter_modus: { hidden: true },
            gelesene_hinweise_ausblenden: { hidden: true },
            unternehmensart: { hidden: true },
            plz: { hidden: true },
            externer_berater: { hidden: true },
            etool_test: { hidden: !isAdmin },
            berater_zugriff: { hidden: privat_flag, paddingTop: 0 },
            co2_fussabdruck_modus: {
                readonly: kultur_flag,
                label: !kultur_flag ? 'Möchten Sie statt der kompakten Datenerfassung lieber \ndetaillierte Datenerfassung nutzen?' : undefined,
                bundle_text: !kultur_flag ? 'name2' : undefined,
                hidden: kultur_flag
            },
            co2_fussabdruck_sachanlagen: { hidden: !co2_fussabdruck_modus_ghg || privat_flag },
            veranstaltungen: { hidden: !kultur_flag },
            auto_save_intervall: { hidden: !isAdmin },
            alternatives_system: (alternatives_system !== 1 || kultur_flag || privat_flag) ? { hidden: !isAdmin } : {},
            vsme: { hidden: !isAdmin || (isAdmin && privat_flag) },
            vorsteuerabzugsberechtigt: { hidden: handwerk_flag || privat_flag },
            anwendungskontext: { hidden: privat_flag },
            kosten_erfassen: { hidden: !showKosten }
        },
        // customAllowContinue: (dataItem: any) => {
        //     return dataItem && dataItem.startjahr_datenerfassung && +dataItem.startjahr_datenerfassung > 2000;
        // },
        onFormChangeInteractive: (formData: WFormData, onValueChange: (name: string, value: any) => void) => {
            if (bereichKey !== 'sonstige') {
                // WKETOOL-102: 453
                // Wenn man als Nutzer:in die Frage 'berater_zugriff' mit Nein beantwortet,
                // dann wird die Berater:innen-Zuordnung automatisch gelöscht und es kommt kein Fehlerhinweis.
                const bz = formData.getValue('berater_zugriff');
                const savedBerater = dataGlobal.RES_MAIN_LOAD_BERATER;
                if (+bz !== 1) {
                    if (Array.isArray(savedBerater) && savedBerater.length > 0) {
                        onValueChange('berater_zugriff', 1);
                        const info = 'Bitte entfernen Sie zunächst den bzw. die ausgewählten Berater!';
                        alert(info);
                    }
                }
            }
            const dm = formData.getValue('daten_maschinen');
            const as = formData.getValue('alternatives_system');
            // console.log('dm as', dm, as);
            if (+dm !== 1 && +as === 1) {
                alert('Sie haben die Testierung gemäß dem Alternativen System ausgewählt. ' +
                    'Hierfür ist die Erfassung Ihrer Maschinen/Anlagen zwingend erforderlich. ' +
                    'Die entsprechenden Konfigurations-Parameter wurden automatisch aktiviert.');
                onValueChange('daten_maschinen', 1);
            }
        },
        // blockMessage: 'Bitte geben Sie ein Startjahr für die Datenerfassung ein!',
        // blockText: 'Bitte geben Sie ein Startjahr für die Datenerfassung ein!',
        disableFieldSelectDefaultOptions: {
            vsme: true,
            energiesteuerrueckerstattung: true,
            alternatives_system: true,
            anwendungskontext: true,
            berater_zugriff: true,
            co2_fussabdruck: true,
            co2_fussabdruck_modus: true,
            co2_fussabdruck_sachanlagen: true,
            daten_elektrofahrzeuge: true,
            daten_erneuerbare_energien: true,
            daten_fahrzeuge: true,
            daten_kraftstoffe_standort: true,
            daten_maschinen: true,
            vorsteuerabzugsberechtigt: true,
            daten_standorte_energietraeger: true,
            daten_standorte_gebaeude: true,
            daten_zustaendigkeiten: true,
            etool_test: true,
            gefuehrter_modus: true,
            mehrere_standorte: true,
            veranstaltungen: true,
            start_hinweis: true,
            unternehmensart: true
        },
        ...(customCfg || {})
    };

    const modulSelected: string = (dataGlobal || {}).MODUL_SELECTED;
    if (modulSelected === 'classic') {
        eingabe_konfig.customFormConfig.co2_fussabdruck_modus = { hidden: true };
    } else if (modulSelected === 'cfm') {
        eingabe_konfig.customFormConfig.daten_fahrzeuge = { hidden: true };
        eingabe_konfig.customFormConfig.daten_maschinen = { hidden: true };
        eingabe_konfig.customFormConfig.co2_fussabdruck_modus = { hidden: true };
        eingabe_konfig.customFormConfig.co2_fussabdruck_sachanlagen = { hidden: false };
        eingabe_konfig.customFormConfig.anwendungskontext = { hidden: true };
        eingabe_konfig.customFormConfig.alternatives_system = { hidden: true };
    } else if (modulSelected === 'steuer') {
        eingabe_konfig.customFormConfig.energiesteuerrueckerstattung = {
            hidden: false,
            sysTxtKeyHinweis: 'hinweis_konfig_energiesteuerrueckerstattung'
        };
        eingabe_konfig.customFormConfig.mehrere_standorte = {
            hidden: false,
            sysTxtKeyHinweis: 'hinweis_konfig_mehrere_standorte'
        };
        eingabe_konfig.customFormConfig.datenerfassung = { hidden: true };
        eingabe_konfig.customFormConfig.daten_erneuerbare_energien = { hidden: true };
        eingabe_konfig.customFormConfig.daten_fahrzeuge = { hidden: true };
        eingabe_konfig.customFormConfig.daten_maschinen = { hidden: true };
        eingabe_konfig.customFormConfig.erweiterte_funktionen = { hidden: true };
        eingabe_konfig.customFormConfig.co2_fussabdruck = { hidden: true };
        eingabe_konfig.customFormConfig.co2_fussabdruck_modus = { hidden: true };
        eingabe_konfig.customFormConfig.co2_fussabdruck_sachanlagen = { hidden: true };
        eingabe_konfig.customFormConfig.anwendungskontext = { hidden: true };
        eingabe_konfig.customFormConfig.alternatives_system = { hidden: true };
    }

    return eingabe_konfig;
}
